import { BaseDto } from '../base.dto';
import { UserBriefDto } from '../user-brief.dto';
import { IsDefined, IsInt, IsISO8601, IsNumber, IsOptional, IsString, Length, ValidateNested } from 'class-validator';
import { Exclude, Type } from 'class-transformer';
import { EmployeeBriefDto } from '../employee-brief.dto';

export class CostCentreCashCountCreateManyDto {
  @ValidateNested({each: true})
  @Type(() => BankingSafeCountDetailDto)
  bulk: BankingSafeCountDetailDto[];
}

export class BankingSafeCountDetailDto extends BaseDto {
  @IsDefined()
  @IsInt()
  costCentreId: number;

  @IsDefined()
  @IsInt()
  currencyId: number;

  @IsOptional()
  @IsInt()
  safeCountHeaderId: number;

  @Exclude()
  key: string;

  @IsDefined()
  @IsInt()
  safeId: number;

  @IsDefined()
  @IsString()
  @Length(1, 45)
  action: string;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  value: number

  @IsDefined()
  @IsInt()
  quantity: number;

  @IsOptional()
  @IsInt()
  bags: number;

  @IsDefined()
  @IsString()
  @Length(1, 45)
  type: string;

  @IsDefined()
  @IsISO8601()
  day: string;

  @IsOptional()
  @IsString()
  @Length(1, 45)
  countedWhen: string;

  @IsOptional()
  @IsInt()
  countedTimes: number;

  @IsOptional()
  @Exclude()
  lastModifiedUser?: UserBriefDto;

  @IsOptional()
  @IsInt()
  lastModifiedEmployeeId: number;

  @IsOptional()
  @Exclude()
  lastModifiedEmployee?: EmployeeBriefDto;
}
